// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const def_breakpoints = {
  mob: 300,
  tblt_prt: 700,
  tblt_ls: 1000,
  desk_sm: 1200,
  desk_md: 1400,
};

// —————————————————————————————————————— INIT. METHOD DEF. ——————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

let viewportState = {
  is_mob: false,
  is_tablet_prt: false,
  is_tablet_ls: false,
  is_desk_sm: false,
  is_desk_md: false,
};

export function init_viewportState(
  { breakpoints = def_breakpoints } = {
    breakpoints: def_breakpoints,
  }
) {
  //////////////////////////////////////////// Setup /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // ...

  //////////////////////////////////////////// ACTION ////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // Set viewport state...
  const w_viewport = window.innerWidth;
  viewportState = {
    is_mob: w_viewport < breakpoints.tblt_prt,
    is_tablet_prt: w_viewport >= breakpoints.tblt_prt && w_viewport < breakpoints.tblt_ls,
    is_tablet_ls: w_viewport >= breakpoints.tblt_ls && w_viewport < breakpoints.desk_sm,
    is_desk_sm: w_viewport >= breakpoints.desk_sm,
    is_desk_md: w_viewport >= breakpoints.desk_md,
  };

  /////////////////////////////////////////// Conclude ///////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // ...
}

export function get_viewportState() {
  return viewportState;
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
